export default __webpack_public_path__ + "static/banner-6b2853eaaa439a450a0bc5f6df037b33.webp";